import SuperParcel from '../../bootstrap/api/Parcel';

/**
 * @abstract
 */
export default class Parcel extends SuperParcel {

    constructor() {
        super();

        this.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        this.setRequestHeader('X-CSRF-TOKEN', window.DATA.csrfToken);
    }

}
